import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';

function Maintenance() {
  return (
    <div style={{
      height: "100vh",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      flexDirection: "column",
      fontFamily: "Arial"
    }}>
      <h1>We’ll be back soon</h1>
      <p>This site is temporarily offline for updates.</p>
    </div>
  );
}

ReactDOM.render(
  <React.StrictMode>
    <Maintenance />
  </React.StrictMode>,
  document.getElementById('root')
);
